import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, LogOut } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_inbody-powered/artifacts/cgjm5igj_FB%20Cover%20logo.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const dash = user && user.role === "nutrition_therapist" ? "/dashboard"
    : user && user.role === "admin" ? "/admin" : "/portal";

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E7E5E4]">
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src={LOGO} alt="My Best Body Club" className="h-[4.5rem] w-auto object-contain rounded-lg" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm text-[#57534E] hover:text-navy transition-colors" data-testid="nav-home">Home page</Link>
          <Link to="/about" className="text-sm text-[#57534E] hover:text-navy transition-colors" data-testid="nav-about">About</Link>
          <Link to="/sport" className="text-sm text-[#57534E] hover:text-navy transition-colors" data-testid="nav-sport">Sport</Link>
          <Link to="/inner-circle" className="text-sm font-semibold hover:opacity-80 transition-opacity" style={{ color: "#B8912A" }} data-testid="nav-inner-circle">Inner Circle</Link>
          <a href="/#pricing" className="text-sm text-[#57534E] hover:text-navy transition-colors">Membership</a>
          <Link to="/therapists" className="text-sm text-[#57534E] hover:text-navy transition-colors" data-testid="nav-therapists">For Therapists</Link>
          {user ? (
            <div className="flex items-center gap-3">
              <Link to={dash} className="text-sm font-medium text-navy" data-testid="nav-dashboard">Dashboard</Link>
              <button onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout"
                className="inline-flex items-center gap-2 text-sm text-[#57534E] hover:text-navy">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login" className="text-sm font-medium text-navy hover:text-navy-dark" data-testid="nav-login">Login</Link>
              <Link to="/join" data-testid="nav-join"
                className="bg-navy text-white hover:bg-navy-dark transition-colors rounded-full px-6 py-2.5 text-sm font-medium">
                Join the Club
              </Link>
            </div>
          )}
        </div>

        <button className="md:hidden text-navy" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#E7E5E4] bg-white px-6 py-4 flex flex-col gap-4">
          <Link to="/" onClick={() => setOpen(false)} className="text-sm text-[#57534E]">Home page</Link>
          <Link to="/about" onClick={() => setOpen(false)} className="text-sm text-[#57534E]">About</Link>
          <Link to="/sport" onClick={() => setOpen(false)} className="text-sm text-[#57534E]">Sport</Link>
          <Link to="/inner-circle" onClick={() => setOpen(false)} className="text-sm font-semibold" style={{ color: "#B8912A" }}>Inner Circle</Link>
          <a href="/#pricing" onClick={() => setOpen(false)} className="text-sm text-[#57534E]">Membership</a>
          <Link to="/therapists" onClick={() => setOpen(false)} className="text-sm text-[#57534E]">For Therapists</Link>
          {user ? (
            <>
              <Link to={dash} onClick={() => setOpen(false)} className="text-sm font-medium text-navy">Dashboard</Link>
              <button onClick={() => { logout(); navigate("/"); setOpen(false); }} className="text-left text-sm text-[#57534E]">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm font-medium text-navy">Login</Link>
              <Link to="/join" onClick={() => setOpen(false)} className="bg-navy text-white rounded-full px-6 py-2.5 text-sm text-center">Join the Club</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
